import {Injectable} from '@angular/core';
import {Observable, of} from 'rxjs';
import {map} from 'rxjs/operators';
import {ApiService} from '../api.service';
import {AuthService} from '../auth.service';

export type OrganizationOption = {
    id: number;
    name: string;
};

@Injectable({
    providedIn: 'root',
})
export class OperationsOrganizationService {
    constructor(
        private authService: AuthService,
        private apiService: ApiService,
    ) {
    }

    canFilterByOrganization(): boolean {
        return this.authService.isSuperUser();
    }

    getCurrentOrganizationId(): number | null {
        const orgId = this.authService.getCurrentUserInfo()?.orgId;
        if (!orgId) {
            return null;
        }
        const parsed = Number(orgId);
        return Number.isNaN(parsed) ? null : parsed;
    }

    resolveOrganizationId(filterOrgId?: string | null): number | string | undefined {
        if (this.canFilterByOrganization()) {
            return filterOrgId?.trim() ? filterOrgId : undefined;
        }
        return this.getCurrentOrganizationId() ?? undefined;
    }

    loadOrganizationOptions(): Observable<OrganizationOption[]> {
        if (!this.canFilterByOrganization()) {
            return of([]);
        }
        return this.apiService.getOrganizations(1000).pipe(
            map((response: { results?: OrganizationOption[] }) => response?.results || []),
        );
    }
}
